module.exports = __webpack_public_path__ + "img/shareText.e4c1a021.png";